import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosWIS";

export const useAssignees = (
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<User>> =>
  useSwr<ApiArrayResponse<User>>(`/api/Incidents/Assignees`, config);
